import { render, staticRenderFns } from "./DocumentWarehouseState.vue?vue&type=template&id=08944781&scoped=true"
import script from "./DocumentWarehouseState.vue?vue&type=script&lang=js"
export * from "./DocumentWarehouseState.vue?vue&type=script&lang=js"
import style0 from "./DocumentWarehouseState.vue?vue&type=style&index=0&id=08944781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08944781",
  null
  
)

export default component.exports